import { isAtMostMobile, useBreakpointRange } from '@optimus-web/breakpoints';
import { IconName } from '@optimus-web/icons';
import { BreakpointRangeWithFallback } from '../types';
import { getBreakpointRangeValueFallback } from '../utils';
import { AccordionIconButtonElement } from './style';

interface AccordionIconButtonProps {
    expanded: boolean;
}

export const AccordionIconButton = ({ expanded }: AccordionIconButtonProps) => {
    const breakpointRange = useBreakpointRange<BreakpointRangeWithFallback>();
    const isMobile = isAtMostMobile(getBreakpointRangeValueFallback(breakpointRange));
    return (
        <AccordionIconButtonElement
            aria-label={expanded ? 'collapse' : 'expand'}
            icon={IconName.ChevronDown}
            expanded={expanded}
            aria-expanded={expanded}
            size={isMobile ? 'medium' : 'small'}
        />
    );
};
